import { Badge } from "@exhousing/design-system";
import { ArrowLeft } from "lucide-react";
import { Link, useParams } from "react-router-dom";

import { DocumentsPanel } from "@/components/DocumentsPanel";
import { CorrespondencePanel } from "@/components/inbox/CorrespondencePanel";
import { NotesPanel } from "@/components/NotesPanel";
import { TenantDetailsCard } from "@/components/party/TenantDetailsCard";
import { PreferencesCard } from "@/components/tenant/PreferencesCard";
import { useTenant } from "@/hooks/api/useParties";

export function TenantDetailPage() {
  const { id } = useParams<{ id: string }>();
  const { data: tenant, isLoading, isError } = useTenant(id);

  if (isLoading) return <p className="text-sm text-muted-foreground">Loading…</p>;
  if (isError || !tenant)
    return <p className="text-sm text-destructive">Tenant not found.</p>;

  const c = tenant.contact;
  return (
    <div className="space-y-6">
      <Link
        to="/parties"
        className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground"
      >
        <ArrowLeft className="size-4" />
        Landlords &amp; tenants
      </Link>

      <header className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h1 className="font-display text-3xl font-medium tracking-tight">
            {c.display_name}
          </h1>
          <div className="mt-2 flex gap-2">
            {tenant.tenant_type && <Badge tone="brand">{tenant.tenant_type}</Badge>}
            {tenant.is_subscriber && <Badge tone="neutral">Subscriber</Badge>}
            <Badge tone={tenant.is_active ? "success" : "neutral"}>
              {tenant.is_active ? "Active" : "Inactive"}
            </Badge>
          </div>
        </div>
      </header>

      <TenantDetailsCard tenant={tenant} />

      <PreferencesCard tenantId={tenant.id} preferences={tenant.preferences} />

      <DocumentsPanel
        subjectType="tenant"
        subjectId={tenant.id}
        hint="Income statement, employment contract, guarantor docs, ID."
      />
      <CorrespondencePanel entityType="contact" entityId={c.id} />
      <NotesPanel subjectType="tenant" subjectId={tenant.id} />
    </div>
  );
}
